<template>
    <v-menu offset-y nudge-bottom="10" left transition="slide-y-transition"
        content-class="students-actions-menu" :close-on-content-click="true">
        <template v-slot:activator="{ on, attrs, value }">
            <v-btn v-on="on" v-bind="attrs" fab depressed height="40" width="40"
                class="students-fab mr-3" :class="{ 'students-fab--open': value }">
                <v-icon size="20" color="#0C0E12">{{ value ? 'mdi-close' : 'mdi-plus' }}</v-icon>
            </v-btn>
        </template>
        <v-list class="py-1 students-actions-list" color="surface">
            <v-list-item v-for="(item, i) in items" :key="i" @click="onAction(item.event)"
                class="students-action-item">
                <v-list-item-icon class="my-0 mr-3 align-self-center">
                    <span class="action-icon-box">
                        <v-icon size="15">{{ item.icon }}</v-icon>
                    </span>
                </v-list-item-icon>
                <v-list-item-title class="action-label">{{ item.label }}</v-list-item-title>
            </v-list-item>
            <v-divider class="my-1 mx-2" />
            <v-list-item @click="onAction('invitations')" class="students-action-item action-muted">
                <v-list-item-icon class="my-0 mr-3 align-self-center">
                    <span class="action-icon-box action-icon-box--muted">
                        <v-icon size="15">mdi-email-outline</v-icon>
                    </span>
                </v-list-item-icon>
                <v-list-item-title class="action-label">{{ $t('coach.pending_invitations') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onAction('admin')" class="students-action-item action-muted">
                <v-list-item-icon class="my-0 mr-3 align-self-center">
                    <span class="action-icon-box action-icon-box--muted">
                        <v-icon size="15">mdi-pencil-outline</v-icon>
                    </span>
                </v-list-item-icon>
                <v-list-item-title class="action-label">{{ $t('common.admin_teams_groups') }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { EventBus } from '@/utils/EventBus'

export default {
    name: 'StudentsActions',
    computed: {
        items(vm = this) {
            return [
                { label: vm.$t('coach.invite_student'), icon: 'mdi-account-plus-outline', event: 'invite' },
                { label: vm.$t('common.add_group'), icon: 'mdi-account-multiple-plus-outline', event: 'add_group' },
                { label: vm.$t('common.add_team'), icon: 'mdi-account-group-outline', event: 'add_team' },
            ]
        }
    },
    methods: {
        onAction(event) {
            EventBus.$emit(`students:${event}`)
        }
    }
}
</script>

<style scoped>
.students-actions-list {
    min-width: 210px;
}

.students-fab {
    background: var(--brand-gradient) !important;
    box-shadow: 0 4px 16px rgba(204, 255, 51, 0.3) !important;
    transition: transform 0.15s, box-shadow 0.15s;
}

.students-fab:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 20px rgba(204, 255, 51, 0.4) !important;
}

.action-icon-box {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.15), rgba(51, 153, 153, 0.15));
    display: flex;
    align-items: center;
    justify-content: center;
}

.action-icon-box .v-icon {
    color: var(--v-primary-base);
}

.theme--light .action-icon-box {
    background: rgba(51, 153, 153, 0.12);
}

.theme--light .action-icon-box .v-icon {
    color: var(--v-accent-base);
}

.action-icon-box--muted {
    background: var(--v-surface2-base);
}

.action-icon-box--muted .v-icon,
.theme--light .action-icon-box--muted .v-icon {
    color: var(--v-txtMuted-base);
}

.action-label {
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: var(--v-txtPrimary-base);
}

.action-muted .action-label {
    color: var(--v-txtSecondary-base);
}
</style>
